<template lang="pug">
  section.section
    .scroll-table.table-border
      b-table(
        :data="new_kakuzais"
        :loading="loading"
        narrowed
        hoverable
        striped
        paginated
        per-page="100"
        id="kakuzai-register-table"
        )
        template(slot-scope="props")
          b-table-column(field="No." label="No." width="50")
            | {{ props.row.i }}
          b-table-column(field="isbn" label="書籍名 : ISBN(代表)" width="400")
            | {{ bookName(props.row.isbn) }}
          b-table-column(field="agency_code" label="帳合" width="100")
            | {{ agencyName(props.row.agency_code) }}
          b-table-column(field="agency_shop_code" label="取次書店コード" width="90")
            | {{ props.row.agency_shop_code }}
          b-table-column(field="bansen" label="番線" width="70")
            | {{ props.row.bansen }}
          b-table-column(field="bibo" label="備考" width="300")
            | {{ props.row.bibo }}
          b-table-column(field="shop_person" label="書店担当" width="100")
            | {{ props.row.shop_person }}
          b-table-column(field="sales_person_id" label="営業担当" width="70")
            | {{ salesPersonName(props.row.sales_person_id) }}
    .field.is-grouped
      .control
        button(@click="backToNew" class="button is-primary control back-button")
          b-icon(pack="fas" custom-class="fa-sm fa-chevron-left")
          span 戻る
      .control
        button(@click="submit" class="button is-danger control submit-button")
          b-icon(pack="fas" custom-class="fa-sm fa-plus")
          span 登録する
</template>

<script>
  export default {
    name: 'kauzais-confirm-table',
    props: {
      new_kakuzais: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        loading: false
      }
    },
    computed: {
      books(){ return this.$store.getters['Books/records'] },
      agencies(){ return this.$store.getters['Agencies/records'] },
      final_book_shop_agencies(){ return this.$store.getters['FinalBookShopAgencies/records'] },
      final_book_shops(){ return this.$store.getters['FinalBookShops/records'] },
      sales_people(){ return this.$store.getters['SalesPeople/records'] },
    },
    methods: {
      bookName(value){
        if (!value) return ''
        const book = this.books.find(book => book.isbn == value)
        return book ? `${book.name} : ${book.isbn}` : ''
      },
      shopName(agency_code, agency_shop_code, book_shop_name){
        if(book_shop_name) return book_shop_name
        if (!agency_code) return ''
        const final_book_shop_agency = this.final_book_shop_agencies
            .find(final_book_shop_agency => final_book_shop_agency.agency_code == agency_code && final_book_shop_agency.agency_shop_code == agency_shop_code)
        return final_book_shop_agency ? final_book_shop_agency.name : ''
      },
      agencyName(agency_code){
        if (!agency_code) return ''
        const agency = this.agencies.find(agency => agency.code == agency_code)
        return agency ? agency.name : ''
      },
      salesPersonName(sales_person_id) {
        const sales_person = this.sales_people.find(sales_person => sales_person.id == sales_person_id)
        return sales_person ? sales_person.name : ''
      },
      backToNew() {
        this.$emit('showConfirmTable', false)
      },
      submitRequest() {
        const url = '/api/v1/multiple_kakuzais.json'
        const method = 'post'
        const params = {
          multiple_kakuzai: {
            kakuzais_attributes: this.new_kakuzais,
          }
        }
        return this.$http({ method: method, url: url, data: params })
      },
      submit() {
        this.loading = true
        this.submitRequest().then(data => {
          this.loading = true
          this.$toast.open({
            message: '登録に成功しました。',
            type: 'is-danger',
            position: 'is-bottom',
          })
          location.href = "/users/multiple_kakuzais"
        })
        .catch((error) => {
          this.loading = false
          this.$toast.open({
            message: '登録に失敗しました。',
            type: 'is-danger',
            position: 'is-bottom',
          })
          throw error
        })
      }
    }
  }
</script>
